import { render, staticRenderFns } from "./damageItemCamera.pug?vue&type=template&id=ca17b04c&lang=pug&external"
import script from "./damageItemCamera.js?vue&type=script&lang=js&external"
export * from "./damageItemCamera.js?vue&type=script&lang=js&external"
import style0 from "./damageItemCamera.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca17b04c')) {
      api.createRecord('ca17b04c', component.options)
    } else {
      api.reload('ca17b04c', component.options)
    }
    module.hot.accept("./damageItemCamera.pug?vue&type=template&id=ca17b04c&lang=pug&external", function () {
      api.rerender('ca17b04c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/multidamageList/components/damageItemCamera/index.vue"
export default component.exports